[
  {
    "id": "GET-E7P-L206-001",
    "module": "Getalbegrip",
    "difficulty": 206,
    "question": "Een prijs stijgt van € 40 naar € 50. Hoeveel procent stijging is dat?",
    "options": [
      "25%",
      "20%",
      "10%",
      "125%"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten_stijging",
    "familyId": "GET-PROC-STIJGING",
    "explanation": "Het verschil is 10 euro. 10 van de 40 is $\\frac{10}{40}$ = $\\frac{1}{4}$. Een kwart is 25%.",
    "distractorExplanations": {
      "1": "Je hebt gerekend met het nieuwe bedrag (10 van de 50).",
      "2": "Dat is de absolute stijging in euro's.",
      "3": "Dat is het nieuwe percentage t.o.v. het oude."
    }
  },
  {
    "id": "GET-E7P-L206-002",
    "module": "Getalbegrip",
    "difficulty": 206,
    "question": "Reken uit: $\\frac{3}{4}$ : $\\frac{1}{8}$ =",
    "options": [
      "6",
      "3",
      "$\\frac{3}{32}$",
      "4"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_delen",
    "familyId": "GET-BREUK-DELEN",
    "explanation": "Delen door een breuk is vermenigvuldigen met het omgekeerde. $\\frac{3}{4}$ $\\times$ $\\frac{8}{1}$ = $\\frac{24}{4}$ = 6. Of: hoe vaak past $\\frac{1}{8}$ in $\\frac{3}{4}$? $\\frac{3}{4}$ = $\\frac{6}{8}$. Het past er 6 keer in.",
    "distractorExplanations": {
      "1": "Je hebt een rekenfout gemaakt.",
      "2": "Je hebt teller keer teller en noemer keer noemer gedaan.",
      "3": "Je hebt een schattingsfout gemaakt."
    }
  },
  {
    "id": "GET-E7P-L206-003",
    "module": "Getalbegrip",
    "difficulty": 206,
    "question": "Je spaart € 1.200 tegen 4% rente per jaar. Hoeveel heb je na 2 jaar (met rente op rente)?",
    "options": [
      "€ 1.297,92",
      "€ 1.296,00",
      "€ 1.248,00",
      "€ 1.300,00"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "rente_op_rente",
    "familyId": "GET-PROC-RENTE",
    "explanation": "Jaar 1: 4% van 1200 = 48. Totaal 1248. Jaar 2: 4% van 1248 = 49,92. Totaal 1248 + 49,92 = 1297,92.",
    "distractorExplanations": {
      "1": "Je hebt 2 keer 48 euro gerekend (geen rente op rente).",
      "2": "Dit is na 1 jaar.",
      "3": "Je hebt grof afgerond."
    }
  },
  {
    "id": "GET-E7P-L206-004",
    "module": "Getalbegrip",
    "difficulty": 206,
    "question": "Welk getal is XI in Romeinse cijfers?",
    "options": [
      "11",
      "9",
      "12",
      "21"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "romeinse_cijfers",
    "familyId": "GET-ROMEINS",
    "explanation": "X = 10, I = 1. De I staat erachter, dus optellen. 10 + 1 = 11.",
    "distractorExplanations": {
      "1": "Dat is IX (I staat ervoor).",
      "2": "Dat is XII.",
      "3": "Dat is XXI."
    }
  },
  {
    "id": "GET-E7P-L206-005",
    "module": "Getalbegrip",
    "difficulty": 206,
    "question": "Wat is het kleinste gemene veelvoud van 4 en 6?",
    "options": [
      "12",
      "24",
      "2",
      "10"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "kgv",
    "familyId": "GET-KGV",
    "explanation": "Tafels van 4: 4, 8, 12, 16... Tafels van 6: 6, 12, 18... Het eerste getal dat in beide rijen staat is 12.",
    "distractorExplanations": {
      "1": "Dit is 4 x 6, maar er is een kleiner veelvoud.",
      "2": "Dit is de grootste gemene deler.",
      "3": "10 zit niet in de tafel van 4 en 6."
    }
  }
]